import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { CustomerAuthActions } from './customer-auth.actions';
import * as CustomerAuthSelectors from './customer-auth.selectors';

@Injectable()
export class CustomerAuthFacade {
    isCookiesAccepted$: Observable<boolean> = this.store.select(CustomerAuthSelectors.getIsCookiesAccepted);
    data$: Observable<any> = this.store.select(CustomerAuthSelectors.getData);

    constructor(private store: NgRedux<any>, private action: CustomerAuthActions) {}

    acceptCookies(value: boolean) {
        this.store.dispatch(this.action.acceptCookies(value));
    }
}
